import React from 'react';

import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import { type ColumnProps } from '@amzn/meridian/column/column';
import Row from '@amzn/meridian/row';

const COLUMN_MAP = {
  1: '12',
  2: '6',
  3: '4',
  4: '3',
  6: '2',
  12: '1',
} as const;

interface GridProps extends ColumnProps {
  columns: 1 | 2 | 3 | 4 | 6;
  showRowDividers?: boolean;
}

/**
 * Display a list of components in a Grid style format. Useful for when you're
 * dealing with a dynamic list of component.
 *
 * Note that the Meridian grid system is based on 12.
 * Documentation: https://meridian.a2z.com/for-developers/react-web/guides/grid-and-layout/?platform=react-web
 */
const Grid = (props: GridProps) => {
  const { columns, children: childrenProps } = props;
  const children = React.Children.toArray(childrenProps);

  // Setup widths
  const widths: string[] = [];
  const gridSize = COLUMN_MAP[columns];
  for (let i = 0; i < columns; i++) {
    widths.push(`grid-${gridSize}`);
  }

  return (
    <Column>
      {children.map((_, i) => {
        if (i % columns !== 0) {
          return;
        }
        const cols = new Array(columns).fill(null);
        return (
          <Row key={i} widths={widths} alignmentVertical="top">
            {cols.map((_, j) => (
              <Box key={`${i}-${j}`}>{children[i + j]}</Box>
            ))}
          </Row>
        );
      })}
    </Column>
  );
};

export default Grid;
